export const SET_DEFAULT_TEXTS = 'SET_DEFAULT_TEXTS';
export const SET_MODAL_VISIBLE = 'SET_MODAL_VISIBLE';
export const USER_TEXTS_GENERATED = 'USER_TEXTS_GENERATED';
export const MODAL_CLOSED = 'MODAL_CLOSED';




// WEBPACK FOOTER //
// ./src/redux/action-types/ui/babyPage.js